/* Brainy kiwi variant — exposed oversized brain with thought emanation. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderBrainy(p: KiwiPalette) {
  return (
    <>
      {/* Exposed brain dome — bulging above head */}
      <path d="M10 0H22V2H24V6H22V8H10V6H8V2H10V0Z" fill={p.accent} opacity={0.35} />
      {/* Brain folds / wrinkles */}
      <rect x="11" y="1" width="4" height="1" fill={p.accent} opacity={0.5} />
      <rect x="17" y="1" width="4" height="1" fill={p.accent} opacity={0.45} />
      <rect x="10" y="3" width="3" height="1" fill={p.accent} opacity={0.4} />
      <rect x="15" y="3" width="4" height="1" fill={p.accent} opacity={0.5} />
      <rect x="20" y="3" width="2" height="1" fill={p.accent} opacity={0.4} />
      <rect x="12" y="5" width="4" height="1" fill={p.accent} opacity={0.45} />
      <rect x="18" y="5" width="3" height="1" fill={p.accent} opacity={0.4} />

      {/* Thought emanation sparkles */}
      <rect x="26" y="0" width="2" height="2" fill={p.accent} opacity={0.3} />
      <rect x="24" y="4" width="2" height="2" fill={p.accent} opacity={0.2} />
      <rect x="28" y="3" width="1" height="1" fill={p.accent} opacity={0.15} />

      {/* Body — shifted down for big brain room */}
      <path d="M12 8H20V10H24V12H26V18H24V22H20V24H12V22H8V18H6V12H8V10H12V8Z" fill={p.body} />

      {/* Highlight */}
      <rect x="20" y="12" width="2" height="2" fill={p.highlight} opacity={0.3} />

      {/* Beak */}
      <path d="M4 14H6V16H4V14ZM2 16H4V18H2V16ZM2 18H4V20H2V18ZM4 20H6V22H4V20Z" fill={p.beak} />

      {/* Eye — wide and alert */}
      <rect x="10" y="12" width="8" height="6" fill={p.eyeBg} />
      <rect x="13" y="14" width="2" height="2" fill={p.pupil} />

      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
